<template>
  <div
    class="grey-bg elevation-5 mb-2 rounded overflow-hidden"
  >
    <v-progress-linear
      background-opacity="0"
      color="primary"
      :value="fileRecord.progress()"
    />
    <div class="px-3 py-2">
      <v-row no-gutters>
        <!--        <v-col-->
        <!--          cols="auto"-->
        <!--          class="pl-1 pr-4"-->
        <!--        >-->
        <!--          <v-icon>-->
        <!--            fa fa-grip-lines-->
        <!--          </v-icon>-->
        <!--        </v-col>-->
        <v-col
          cols="auto"
          class="pr-2"
        >
          <v-icon
            v-if="fileRecord.isPlayableAudio()"
            x-small
            @click="playAv(fileRecord)"
          >
            fa {{ fileRecord.isPlayingAv ? 'fa-stop' : 'fa-play' }}
          </v-icon>
        </v-col>
        <v-col
          class="text-truncate pr-3"
          style="min-width: 0"
        >
          {{ fileRecord.name() }}
        </v-col>
        <v-col cols="auto" />
        <v-col cols="auto">
          {{ fileRecord.size() }}
        </v-col>
        <v-col
          cols="auto"
          class="pl-3"
        >
          <v-icon
            color="error"
            @click="removeFileRecord(fileRecord)"
          >
            fa fa-times
          </v-icon>
        </v-col>
        <div
          v-if="fileRecord.isPlayableAudio() || fileRecord.isPlayableVideo()"
          ref="wrapper"
          class="file-av-wrapper"
        />
      </v-row>
      <div
        v-if="fileRecord.upload.error"
        class="error--text caption"
      >
        {{ fileRecord.upload.error }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FileUploaderFile',
  props: {
    fileRecord: {
      type: Object,
      required: true
    }
  },
  methods: {
    playAv(fileRecord) {
      if (fileRecord.stopAv) {
        fileRecord.stopAv()
        return
      }
      const createObjectURL = (window.URL || window.webkitURL || {}).createObjectURL
      const revokeObjectURL = (window.URL || window.webkitURL || {}).revokeObjectURL

      const player = document.createElement(fileRecord.isAudio() ? 'audio' : 'video')
      if (player instanceof HTMLVideoElement && fileRecord.isPlayableVideo()) {
        this.createThumbnail(fileRecord, player)
      }
      player.controls = true
      // player.style.width = this.prvWidth + 'px';
      // wrapper.appendChild(player)
      const url = fileRecord.url() || createObjectURL(fileRecord.file)
      player.src = url
      player.play()
      fileRecord.isPlayingAv = true
      fileRecord.stopAv = () => {
        // player.src = null;
        player.src = ''
        revokeObjectURL(url)
        fileRecord.isPlayingAv = false
        fileRecord.stopAv = null
      }
    },
    removeFileRecord(fileRecord) {
      if (this.clearFilename()) {
        return
      }
      if (this.disabled === true) {
        return
      }
      this.$emit('remove', fileRecord)
    },
    clearFilename() {
      if (!(this.editable === true && this.isEditInputFocused)) {
        return false
      }
      this.$refs.input.value = ''
      this.isEditCancelable = true
      this.editInputBlured()
      return true
    }
  }
}
</script>

<style scoped>

</style>
